<template>
    <v-snackbar v-model="snackbar.show" :timeout="3000" :color="snackbar.color">
        {{ snackbar.text }}
        <v-btn text @click="snackbar.show = false">
            Close
        </v-btn>
    </v-snackbar>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'Snackbar',
    components: {},
    computed: {
        ...mapState(['snackbar'])
    }
};
</script>

<style></style>
